import _ from 'lodash'

export type DefSort = { [k: string]: any }
export type DefFilter = { [k: string]: any }
export type ExtendSort = string[][]

function appendLimit(params: URLSearchParams, limit?: number | string) {
  if (limit) {
    params.append('limit', limit.toString())
  }
}

function appendOffset(params: URLSearchParams, offset?: number | string) {
  if (offset) {
    params.append('offset', offset.toString())
  }
}

function appendSort(
  params: URLSearchParams,
  sort: DefSort | ExtendSort | null | undefined,
  extendSort: boolean
) {
  if (sort) {
    if (extendSort) {
      for (const sortElement of sort as ExtendSort) {
        params.append('sort', JSON.stringify(sortElement))
      }
    } else {
      params.append('sort', JSON.stringify(sort))
    }
  }
}

function appendFilter(
  params: URLSearchParams,
  filter: DefFilter | null | undefined,
  extendFilter: boolean
) {
  if (filter) {
    if (extendFilter) {
      for (const [key, value] of Object.entries(filter)) {
        params.append(key, _.isString(value) ? value : JSON.stringify(value))
      }
    } else {
      params.append('filter', JSON.stringify(filter))
    }
  }
}

export default function createURLParams(
  limit?: number | string,
  offset?: number | string,
  sort?: DefSort | ExtendSort | null,
  filter?: DefFilter | null,
  extendFilter = true,
  extendSort = false
) {
  const params = new URLSearchParams()
  appendLimit(params, limit)
  appendOffset(params, offset)
  appendSort(params, sort, extendSort)
  appendFilter(params, filter, extendFilter)
  return params
}
